window.ORDER_PAGE_POPUP_HELPERS = {
    clickRateStar() {
        if (this.popup.messageLikeSent) {
            this.popup.title = this.popupTitle[this.popupVariants.reviewSuccess]
            this.popup.variantPopup = this.popupVariants.reviewSuccess
            this.popup.showReview = false
            this.popup.showStarBox = false
            this.popup.buttonsSucessDisabled = false
            this.popupShow = true
            return false
        }

        this.popup.showReview = true
        this.popup.showStarBox = true
        this.popup.title = this.popupTitle[this.popupVariants.like]
        this.popup.variantPopup = this.popupVariants.like
        this.popupShow = true
    },

    sendPopup() {
        switch (this.popup.variantPopup) {
            case this.popupVariants.notLike:
                if (this.popup.review.length <= 5) {
                    this.popup.showReviewError = true
                    return false
                }
                this.popup.showReview = false
                this.popup.showStarBox = false
                this.popup.title = this.popupTitle[this.popupVariants.redirect]
                this.popup.variantPopup = this.popupVariants.redirect
                let ratingTemplate = this.popup.starValue > 0 ? this.popup.starValue : false
                this.sendFeedback(this.popup.review, ratingTemplate, true)
                this.popup.messageNoLikeSent = true
                this.popup.review = ''
                break
            case this.popupVariants.redirect:
                this.popupShow = false
                this.popup.title = this.popupTitle[this.popupVariants.notLike]
                this.popup.variantPopup = this.popupVariants.notLike
                axios({
                    method: 'get',
                    url: '/index.php?action_skin_change=yes&skin_name=SMSv1EN'
                }).then(function() {
                    window.location.href = "/"
                }.bind(this)).catch(function(err) {
                    console.log(err)
                })
                break
            case this.popupVariants.like:
                this.sendFeedback(this.popup.review, this.popup.showStarBox, false)
                this.popupShow = false
                this.popup.messageLikeSent = true
                setTimeout(() => {
                    this.popup.title = this.popupTitle[this.popupVariants.notLike]
                    this.popup.variantPopup = this.popupVariants.notLike
                    this.popup.review = ''
                }, 500)
                break
            case this.popupVariants.reviewSuccess:
                this.popupShow = false
                break
            default:
                this.popupShow = false
                this.popup.title = this.popupTitle[this.popupVariants.notLike]
                this.popup.variantPopup = this.popupVariants.notLike
                this.popup.buttonsSucessDisabled = true
                break
        }
    },

    skipModalReview() {
        this.popup.title = this.popupTitle[this.popupVariants.skipModal]
        this.popup.variantPopup = this.popupVariants.redirect
        this.popup.buttonsSucessDisabled = false
        this.popup.showStarBox = false
        this.popup.showReview = false
    },

    returnBackTemplate() {
        if (this.popup.messageNoLikeSent) {
            this.popup.showReview = false
            this.popup.showStarBox = false
            this.popup.title = this.popupTitle[this.popupVariants.redirect]
            this.popup.variantPopup = this.popupVariants.redirect
            this.popupShow = true
            return false
        }
        this.popup.buttonsSucessDisabled = true
        this.popup.showReview = true
        this.popup.showStarBox = true
        this.popup.title = this.popupTitle[this.popupVariants.notLike]
        this.popup.variantPopup = this.popupVariants.notLike
        this.popupShow = true
    },

    async sendFeedback(text, rate = false, isBack = false) {
        let data = new FormData()
        data.append('method', 'LEAVE_FEEDBACK')
        data.append('text', text)
        if (rate) data.append('rate', '' + rate)
        if (isBack) data.append('isBack', isBack ? '1' : '0')
        axios({
            method: 'post',
            url: '/sms_api/orders.php?n=5-3',
            data: data
        }).then(function() {
        }.bind(this)).catch(function(err) {
            console.log(err)
        })
    }
}
